class Sorting
{
    constructor() {
        this.items = this.getItems()
    }

    getItems() {
        return document.querySelectorAll('.sorting .tabs__item:not(.tabs__item--active)')
    }

    bind() {
        this.items.forEach(tab => {
            tab.addEventListener('click', event => {
                event.preventDefault()

                this.runEvent(tab)

                Array.from(tab.parentNode.children).forEach(item => {
                    $filter.$el[item.dataset.name].value = ''

                    item.classList.toggle('tabs__item--active', tab.dataset.value === '' ? false : item.isEqualNode(tab))
                })

                $filter.$el[tab.dataset.name].value = tab.dataset.value

                $filter.submit()
            })
        })
    }

    clear() {
        this.items.forEach(item => item.classList.remove('tabs__item--active'))
    }

    runEvent(tab) {
        let eventParams = {},
            eventName = /sorting\[([a-z]+)]/gi.exec(tab.dataset.name)[1]

        eventParams[eventName] = tab.dataset.value

        $app.runEvent('sorting', eventParams)
    }
}

module.exports = Sorting